import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FranchiseService } from './franchise.service';
import { Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { HeaderService } from '../header/header.service';
import { Offcanvas } from '../form.offcanvas';
import { ScriptLoader } from '../script-loader';
import { GroupService } from "../groups/groups.service";
import { AppSettings } from "../../config/config";

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var customToastr: any;

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: [
        './../../assets/css/theme-default/bootstrap.css',
        './../../assets/css/theme-default/materialadmin.css',
        './../../assets/css/theme-default/font-awesome.min.css',
        './../../assets/css/theme-default/material-design-iconic-font.min.css',
        /* './../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
        './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
        './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
        './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
        './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
        './../../_crop/css/style.css',
        './../../_crop/css/style-example.css',
        './settings.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [FranchiseService, LoginService, Offcanvas, ScriptLoader]
})


export class FranchiseSettingsComponent implements OnInit {

    constructor(private FranchiseService: FranchiseService, private router: Router,
        private loginservice: LoginService,
        private offcanvas: Offcanvas, private scriptLoader: ScriptLoader) {
    }


    public static gAcademicId = 0;

    getAuthToken = localStorage.getItem('usertoken');
    getSchoolId = localStorage.getItem('schoolinfo');
    preLoader = true;
    todayDate;
    getSchoolName;
    getSchoolImage;
    accountType;
    loginMode = '';
    getSchoolListArray = [];
    bluewingsftrelst = [];
    currentSchoolId;
    dataSource;

    navigateTo(path, data) {
        this.router.navigate(['/' + path], { state: { tab: data } });
    }

    getProperNumber(num) {
        return num < 10 ? '0' + num : num;
    }

    // get today date
    getTodayDate() {
        const getDateNow = new Date();
        const getMonth = getDateNow.getUTCMonth() + 1;
        const getDay = getDateNow.getUTCDate();
        const getYear = getDateNow.getUTCFullYear();

        this.todayDate = getYear + '/' + getMonth + '/' + getDay;

    }


    /*Data table operation*/
    destroyDataTable(table) {
        $('#' + table).DataTable().destroy();
    }
    initializeDataTable(table) {
        setTimeout(function () {
            $('#' + table).DataTable({
                "order": [[0, 'asc']],
            });
            //this.scriptInit();
        }, 500);
    }
    initializeDataTableOrder(table) {
        setTimeout(function () {
            $('#' + table).DataTable({
                "order": []
            });
            //this.scriptInit();
        }, 500);
    }

    getSchoolListData() {
        this.FranchiseService.fetchSchoolListData(this.getSchoolId, this.getAuthToken)
            .subscribe(
                (data: any) => {
                    // init script
                    this.initScripts();
                    setTimeout(() => this.initScripts(), 500);

                    for (let i = 0; i < data.length; i++) {
                        if(data[i].isSuspended == 0){
                            this.getSchoolListArray.push(data[i]);
                        }
                    }

                },
                error =>
                    () => {
                    }
            );
    }

    getFeatureList(schoolId) {
        this.currentSchoolId = schoolId;
        this.bluewingsftrelst = [];
        $(".feature-search-box").val("");
        this.destroyDataTable('feature-table');
        this.FranchiseService.fetchFeatureList(schoolId, this.getAuthToken)
            .subscribe(
                (data: any) => {
                    var blueFeature = data[0];
                    for (var i = 0; i < blueFeature.length; i++) {
                        this.bluewingsftrelst.push(blueFeature[i]);
                        if (blueFeature.length - 1 == i) {
                            this.initializeDataTable('feature-table');
                        }
                    }
                    //sorting the array in asc order
                    this.bluewingsftrelst.sort((a, b) => a.BluewingsFeatureDescription > b.BluewingsFeatureDescription ? 1 : -1);
                },
                error => {

                }
            );
    }

    updateFeatureList(pkSchoolFeatureId, ActiveStatus) {
        this.FranchiseService.updateFeatureList(this.currentSchoolId, pkSchoolFeatureId, ActiveStatus, this.getAuthToken)
            .subscribe(
                (data: any) => {
                    if (data.status) {
                        customToastr("Feature successfully updated", 'success');
                    }
                    else {
                        //this.bluewingsftrelst[index].ActiveStatus = status == 'ENABLED' ? 'DISABLED' : 'ENABLED';
                        customToastr("Failed to update feature,</br>please try again", 'error');
                    }
                },
                error => {
                    //this.bluewingsftrelst[index].ActiveStatus = status == 'ENABLED' ? 'DISABLED' : 'ENABLED';
                    customToastr("Failed to update feature, please try again", 'error');
                }
            );
    }

    searchFeature(filterValue) {
        var filter, tr, td, i, txtValue;
        filter = filterValue.toUpperCase();
        tr = $("#fearture-table .gradeX");

        for (i = 0; i < tr.length; i++) {
            td = tr[i].getElementsByTagName("th")[1];
            txtValue = td.innerHTML;
            if (txtValue.toUpperCase().indexOf(filter) > -1) {
                tr[i].style.display = "";
            } else {
                tr[i].style.display = "none";
            }
        }
    }


    // string wrap to words function  
    //getWords(str,5);
    getWords(str, count) {
        return str.split(/\s+/).slice(0, count).join(' ');
    }


    // token auth
    isValidToken() {
        let isValidToken = false;
        let isValidSchool = 0;
        this.loginservice.isValidToken(this.getAuthToken)
            .subscribe(
                (data: any) => {
                    isValidToken = data.isValid;
                    if (data.errorcode === 10010) {
                        this.router.navigate(['/suspended']);
                    } else if (isValidToken === true) {

                        this.loginservice.isValidSchoolId(this.getSchoolId)
                            .subscribe(
                                (validData: any) => {
                                    isValidSchool = validData.schoolExist;
                                    if (isValidSchool !== 1) {
                                        this.router.navigate(['/login']);
                                    }
                                    else {
                                        if (this.loginMode === 'STAFF') {
                                            this.router.navigate(['/exams']);
                                        }
                                        else {
                                            this.getSchoolListData();
                                        }
                                    }
                                },
                                error => {
                                }
                            );
                    } else {
                        this.router.navigate(['/login']);
                    }
                },
                error => {
                }
            );
    }


    initScripts() {
        this.scriptLoader.loadScript($, 'DASHBOARD');
    }

    ngOnInit() {

        this.isValidToken();

        setTimeout(() => this.initScripts(), 500);
    }

}
